import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { usePermissions } from "../pages/login/PermissionContext";
import { fetchOrgCodeAndValidate } from "../pages/login/indexedDBHelper";
export default function LayoutWithbg({ children }) {
  const { userInfo } = usePermissions();
  const [orgCode, setOrgCode] = useState("");
  const accessToken = sessionStorage.getItem("accessToken");
  useEffect(() => {
    fetchOrgCodeAndValidate((data) => {
      if (data) {
        const { org_code } = data;
        setOrgCode(org_code);
      } else {
        console.error("Failed to fetch data from IndexedDB.");
      }
    });
  }, [accessToken]);
  return (
    <div
      style={{
        // minHeight: "100vh",
        backgroundImage: "url('/newImages/login_background.svg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: "column",
        flex: 1,
      }}
    >
      {/* Header Section */}
      <Grid
        container
        alignItems="center"
        sx={{
          padding: "30px 20px",
          fontFamily: "Arial, sans-serif",
        }}
      >
        {/* Empty space taking 8 columns */}
        <Grid item xs={0} sm={8}></Grid>
        {/* Facility Name - only show if access token is present */}
        {/* {accessToken && (
          <Grid item xs={2}>
            <div
              style={{ fontSize: "14px", fontWeight: "bold", color: "#000" }}
            >
              Facility Name :{" "}
              <span style={{ fontWeight: "normal" }}>
                {userInfo?.facility_name || "-"}
              </span>
            </div>
          </Grid>
        )} */}
          <Grid item xs={0} sm={2}></Grid>
        {/* ORG Code in pill */}
        <Grid item xs={12} sm={6} md={2} sx={{ ml: "auto", display: "flex", justifyContent: "flex-end" }}>
          <div
            style={{
              background: "#fff",
              border: "1px solid #ddd",
              borderRadius: "12px",
              padding: "5px 14px",
              fontSize: "13px",
              fontWeight: "bold",
              color: "#333",
              display: "inline-block",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              whiteSpace: "nowrap",
            }}
          >
            ORG Code : <span style={{ color: "#000" }}>{orgCode || "-"}</span>
          </div>
        </Grid>
      </Grid>
      {/* Page Content */}
      {/* <div style={{ flex: 1 }}>{children}</div> */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: "0 0 40px 0",
        }}
      >
        <div
          style={{
            width: "100vw",
            margin: "0",
            padding: "0",
            backgroundColor: "#FDFDFD",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
